(function () {

  'use strict';

  eclipseApp.factory('prepaidRefillTaxCalculationService', function() {

    var refillAmount = null,
      GST = null,
      HST = null,
      PST = null,
      QST = null,
      total = null;

    function setRefillAmount(data) {
      refillAmount = data;
    }

    function getRefillAmount() {
      return refillAmount;
    }

    function setGST(data) {
      GST = data;
    }

    function getGST() {
      return GST;
    }

    function setHST(data) {
      HST = data;
    }

    function getHST() {
      return HST;
    }

    function setPST(data) {
      PST = data;
    }

    function getPST() {
      return PST;
    }

    function setQST(data) {
      QST = data;
    }

    function getQST() {
      return QST;
    }

    function setTotal(data) {
      total = data;
    }

    function getTotal() {
      return total;
    }

    return {
      setRefillAmount: setRefillAmount,
      getRefillAmount: getRefillAmount,
      setGST: setGST,
      getGST: getGST,
      setHST: setHST,
      getHST: getHST,
      setPST: setPST,
      getPST: getPST,
      setQST: setQST,
      getQST: getQST,
      setTotal: setTotal,
      getTotal: getTotal
    };

  });

})();
